import { createContext, useContext, useState, useEffect } from 'react';

const DesktopModeContext = createContext();

// Detecteer of het apparaat een mobiel apparaat is
const isMobileDevice = () => {
  // Check user agent voor mobiele apparaten
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
  
  // Check ook schermgrootte (minder dan 768px breed is typisch mobiel)
  const isSmallScreen = window.innerWidth < 768;
  
  // Check touch support
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return mobileRegex.test(userAgent.toLowerCase()) || (isSmallScreen && hasTouch);
};

export const useDesktopMode = () => {
  const context = useContext(DesktopModeContext);
  if (!context) {
    throw new Error('useDesktopMode must be used within a DesktopModeProvider');
  }
  return context;
};

export const DesktopModeProvider = ({ children }) => {
  const [desktopMode, setDesktopMode] = useState(() => {
    // Check of er al een voorkeur is opgeslagen
    const saved = localStorage.getItem('wasz-desktop-mode');
    
    // Als er geen voorkeur is opgeslagen, bepaal automatisch op basis van apparaat
    if (saved === null) {
      // Op mobiel: standaard mobiele modus (desktopMode = false)
      // Op desktop: standaard desktop modus (desktopMode = true)
      const isMobile = isMobileDevice();
      return !isMobile; // Als mobiel, dan desktopMode = false (mobiele weergave)
    }
    
    return saved === 'true';
  });

  useEffect(() => {
    // Sla de voorkeur op in localStorage
    localStorage.setItem('wasz-desktop-mode', desktopMode.toString());
    
    // Voeg/verwijder class op de root element voor CSS styling
    // We gebruiken GEEN viewport wijziging meer - alleen CSS classes
    // Dit voorkomt dat iOS Safari de pagina herlaadt
    if (desktopMode) {
      document.documentElement.classList.add('force-desktop');
      document.body.classList.add('force-desktop');
    } else {
      document.documentElement.classList.remove('force-desktop');
      document.body.classList.remove('force-desktop');
    }
  }, [desktopMode]);

  const toggleDesktopMode = () => {
    setDesktopMode(prev => !prev);
  };

  return (
    <DesktopModeContext.Provider value={{ desktopMode, toggleDesktopMode, setDesktopMode }}>
      {children}
    </DesktopModeContext.Provider>
  );
};

export default DesktopModeContext;
